import { MapTo } from "@adobe/aem-react-editable-components";
import { LoyaltyContactFormCheckboxSection } from "@jti/ui";
import { withAemAuthoring } from "../../../app-related/withAemAuthoring";
export const LoyaltyContactFormCheckboxSectionConfig = {
    emptyLabel: "Please fill in checkbox section, please note it must be wrapper in LoyaltyForm",
    isEmpty: (props) => {
        return (!props.sectionName ||
            !props.sectionTitle ||
            !props.checkboxesData ||
            props.checkboxesData?.length === 0 ||
            !props.type);
    },
    getProps: (props) => {
        return props;
    },
};
export default MapTo("loyalty/components/loyaltyContactFormCheckboxSection")(withAemAuthoring(LoyaltyContactFormCheckboxSection, LoyaltyContactFormCheckboxSectionConfig));
